import pinia from '@/store'
import { useConfigStore } from '@/store/config'

export function playSound(name: 'payment' | 'cancel' | 'notification' | 'alert') {
  const config = useConfigStore(pinia)
  if (!config.mute) {
    const sound = new Audio(`${name}.mp3`)
    sound.play()
  }
}
